/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1AccesscontrolUsers200,
  GetApiV1AccesscontrolUsers401,
  GetApiV1AccesscontrolUsers500,
  GetApiV1AccesscontrolUsersQueryParams,
  GetApiV1AccesscontrolUsersQueryResponse,
} from "../../types/accessControlUsersController/GetApiV1AccesscontrolUsers.ts";
import { userSummaryViewModelSchema } from "../userSummaryViewModelSchema.ts";

export const getApiV1AccesscontrolUsersQueryParamsSchema = z.object({
  roleId: z.optional(z.coerce.number().int()),
  controllerId: z.optional(z.coerce.number().int()),
  pageNumber: z.coerce.number().int().default(1),
  pageSize: z.coerce.number().int().default(20),
}) as unknown as ToZod<GetApiV1AccesscontrolUsersQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1AccesscontrolUsers200Schema = z.array(
  z.lazy(() => userSummaryViewModelSchema),
) as unknown as ToZod<GetApiV1AccesscontrolUsers200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1AccesscontrolUsers401Schema =
  z.any() as unknown as ToZod<GetApiV1AccesscontrolUsers401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1AccesscontrolUsers500Schema =
  z.any() as unknown as ToZod<GetApiV1AccesscontrolUsers500>;

export const getApiV1AccesscontrolUsersQueryResponseSchema = z.lazy(
  () => getApiV1AccesscontrolUsers200Schema,
) as unknown as ToZod<GetApiV1AccesscontrolUsersQueryResponse>;
